import React, { Component } from "react";
import Scanner from "react-webcam-qr-scanner";
import request from "../../utils/request";

var scanned = false;

class ScanQrCodeComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            xhrResponse: {
                status: "",
                message: ""
            }
        };
        this.handleDecode = this.handleDecode.bind(this);
        this.handleScannerLoad = this.handleScannerLoad.bind(this);
    }

    handleDecode = (result) => {
        if (scanned || result.data === "") {
            return;
        }
        scanned = true;

        let payload = { "data": result.data };
        request
            .post(this, `api:/event/qr-ticket-import`, payload)
            .then(resp => {
                this.setState({
                    isLoading: false,
                    xhrResponse: resp
                });
                scanned = false;
            });
    }

    handleScannerLoad = (mode) => {};

    render() {
        const { xhrResponse } = this.state;
        if (xhrResponse) {
            if (xhrResponse.status === "error") return "Error scanning QR Code!";
            if (xhrResponse.status === "success") return "QR Code scanned successfully!";
        }
        return (
            <Scanner
                className="qrScannerComponent"
                onDecode={this.handleDecode}
                onScannerLoad={this.handleScannerLoad}
                constraints={{
                    audio: false,
                    video: {
                        facingMode: "environment"
                    }
                }}
                captureSize={{ width: 1280, height: 720 }}
            />
        );
    }
}

export default ScanQrCodeComponent;